import { render, staticRenderFns } from "./SeminarTicketsByChair.vue?vue&type=template&id=462b09e4&scoped=true&"
import script from "./SeminarTicketsByChair.vue?vue&type=script&lang=js&"
export * from "./SeminarTicketsByChair.vue?vue&type=script&lang=js&"
import style0 from "./SeminarTicketsByChair.vue?vue&type=style&index=0&id=462b09e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b09e4",
  null
  
)

export default component.exports